import SlimlineBannerComponent from '@/components/homepage/SlimlineBanner/SlimlineBanner';
import { getAnchorId } from '@/utils/builderUtils';

export default function SlimlineBanner(props) {
  return (
    <div {...getAnchorId(props.anchorLinkID)}>
      <SlimlineBannerComponent {...props} />
    </div>
  );
}
